import app from "flarum/forum/app";
/** Used when the forum has no setting of its own — mirrors the server default. */
const FALLBACK = 3000;

/**
 * How long a message may be in this channel.
 *
 * One helper because three places need the same answer and must not disagree:
 * the composer's counter, the composer's send guard, and the channel form's
 * "currently" hint. A channel's own value wins; null or zero means it follows
 * the forum, which is what the server does in `Channel::maxMessageLength()`.
 */
export function resolveMaxMessageLength(channel) {
  var _channel$maxMessageLe;
  const own = channel == null || (_channel$maxMessageLe = channel.maxMessageLength) == null ? void 0 : _channel$maxMessageLe.call(channel);
  if (own && own > 0) return own;
  return forumMaxMessageLength();
}

/** The forum-wide setting, for channels that do not override it. */
export function forumMaxMessageLength() {
  var _app$forum$attribute;
  const forum = Number((_app$forum$attribute = app.forum.attribute("ramon-chat.maxMessageLength")) != null ? _app$forum$attribute : FALLBACK);
  return forum > 0 ? forum : FALLBACK;
}
flarum.reg.add('ramon-chat', 'forum/utils/messageLimit', { resolveMaxMessageLength: resolveMaxMessageLength,forumMaxMessageLength: forumMaxMessageLength, });